import React from "react";
import { Card } from "components";
import { useSubscriptionStats } from "hooks/useSubscriptionStats";
import { BREAKPOINT } from "constants/styles";
import QuotaUsageBar from "components/workspaces/WorkspaceQuota/QuotaUsageBar";
import { bytesToMB } from "utils/projects";
import Skeleton from "react-loading-skeleton";
import { routes } from "utils/routes";
import RequestBoostBanner from "components/subscription-addons/RequestBoostBanner";
import { useSubscriptionAddons } from "hooks/useSubscriptionAddons";
import { useSubscriptions } from "hooks/useSubscriptions";
import { REQUESTS_BOOST_ADDONS } from "constants/addons";

const SubscriptionUsage = () => {
  const { enhancedSubscription } = useSubscriptions();
  const { stats } = useSubscriptionStats();
  const { addons } = useSubscriptionAddons();

  const boostedRequests = !!addons?.find(
    a => a.type === "REQUESTS_BOOST_1M" || a.type === "REQUESTS_BOOST_300K"
  );

  // requests boost is not available for PPU plan
  const availableBoostAddon =
    !stats?.ppu.active && enhancedSubscription
      ? REQUESTS_BOOST_ADDONS.find(a =>
          a.availableFor.includes(enhancedSubscription.currentPlan.name)
        )
      : false;

  return (
    <>
      <Card
        title="Quota Usage"
        description="Breakdown of resources allotted and used for all your projects across workspaces."
      >
        {!stats && <Skeleton count={1} width="100%" height={38} />}

        {stats && (
          <div className="quota-items">
            <QuotaUsageBar
              resource={{ name: "request" }}
              used={stats.ppu.active ? undefined : stats.used.requests}
              quota={stats.quota.requestLimit}
              data-testid={"usage-bar-request-limit"}
              boosted={boostedRequests}
            />

            <QuotaUsageBar
              resource={{ name: "MB of IPFS", uncountable: true }}
              used={stats.used.storage}
              quota={stats.quota.storageLimit}
              data-testid={"usage-bar-ipfs-limit"}
              formatter={bytesToMB}
            />

            <QuotaUsageBar
              resource={{ name: "MB of Filecoin", uncountable: true }}
              used={stats.used.storageFilecoin}
              quota={stats.quota.storageLimitFilecoin}
              data-testid={"usage-bar-filecoin-limit"}
              formatter={bytesToMB}
            />

            <QuotaUsageBar
              resource={{ name: "project" }}
              used={stats.used.projectCount}
              quota={stats.quota.projectCount}
              data-testid={"usage-bar-project-count"}
            />

            <QuotaUsageBar
              resource={{ name: "webhook" }}
              used={stats.used.webhookCount}
              quota={stats.quota.webhookCount}
              data-testid={"usage-bar-webhook-count"}
            />
          </div>
        )}
        {availableBoostAddon && (
          <RequestBoostBanner
            boost={availableBoostAddon.type}
            style={{ margin: "16px 0px" }}
            successCallbackPath={routes.dashboardSubscription}
            cancelCallbackPath={routes.dashboardSubscription}
          />
        )}
      </Card>

      <style jsx>{`
        .quota-items {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr;
          gap: 16px 48px;
        }

        @media screen and (max-width: ${BREAKPOINT.SM}px) {
          .quota-items {
            grid-template-columns: 1fr 1fr;
          }
        }
      `}</style>
    </>
  );
};

export default SubscriptionUsage;
